import { render, staticRenderFns } from "./acceptance-cert.vue?vue&type=template&id=de312880&scoped=true&"
import script from "./acceptance-cert.vue?vue&type=script&lang=js&"
export * from "./acceptance-cert.vue?vue&type=script&lang=js&"
import style0 from "./acceptance-cert.vue?vue&type=style&index=0&id=de312880&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de312880",
  null
  
)

export default component.exports